import Pagination from '@mui/material/Pagination';

interface PaginationRendererProps {
	currentStep: number;
	stepCount: number;
	onStepChange: (step: number) => void;
}

const PaginationRenderer = ({ currentStep, stepCount, onStepChange }: PaginationRendererProps) => {
	const handleChange = (step: number) => {
		onStepChange(step);
	};

	return (
		<Pagination
			sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: '16px' }}
			count={stepCount}
			page={currentStep}
			onChange={(_, step) => handleChange(step)}
			variant="outlined"
		/>
	);
};

export default PaginationRenderer;
